import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'

//components
import withLocalization from '~/hoc/withLocalization';
import { NumberInput } from '../../../../../elements/Input';
import SwitchWidget from '../../SwitchWidget';
import Select from '../../../../../elements/Select.js';
import WagetypeRefetch from '../../WagetypeRefetch.js';

class MedicalLeaves extends Component {
    constructor(props) {
        super(props);
        const { currentEntity } = props.clientStore;
        const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
        const vacationSetup = Object.assign({}, currentEntity.client.data.Vacation_setup);
        this.payrollIntegration = props.commonStore.config?.integration_details || null;
        this.state = {
            wageType: props.commonStore.getWageTypesAccordingToIntegrations(this.payrollIntegration, 'ab') || [],
            lastUpdated: props.commonStore.getWageTypesAccordingToIntegrations(this.payrollIntegration, 'last_updated') || null,
            isLoadingWageTypes: false,
            enableDefaultHolidaysForAbsence: vacationSetup.enable_default_holidays_for_absence,
            medicalLeaves: {
                allowMedicalLeaveSpliting: basicRules.allowMedicalLeaveSpliting,
                medicalLeaveDaysForEmployer: basicRules.medicalLeaveDaysForEmployer,
                medicalLeaveNewPeriodThresholdDays: basicRules.medicalLeaveNewPeriodThresholdDays || basicRules.medicalLeaveDaysForEmployer,
                medicalLeaveGovtPayrollWagetype: basicRules.medicalLeaveGovtPayrollWagetype || null,
                allowDefaultHolidaysOnMedicalLeave: basicRules.allowDefaultHolidaysOnMedicalLeave || false,
            },
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
    }

    handleChange = (name, value) => {
        const { medicalLeaves } = this.state;
        medicalLeaves[name] = value;
        this.props.handleUserDataChange(name, value);
        this.setState({ medicalLeaves });
    }

    handleSwitch = (name, evt) => {
        const { medicalLeaves } = this.state;
        medicalLeaves[name] = evt;
        this.props.handleUserDataChange(name, evt);
        this.setState({ medicalLeaves })
    }

    refetchWageType = async () => {
        const { commonStore, t } = this.props;
        try {
            await commonStore.refetchWagetypes();
            commonStore.addNotification(t('Successfully refetched wagetypes'), null, 'success');
            const _wagetype = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'ab') || [];
            const _lastUpdated = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'last_updated') || null;
            // const _absenceCode = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'absenceCode') || [];
            this.setState({ wageType: _wagetype, lastUpdated: _lastUpdated, isLoadingWageTypes: false });

        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
            this.setState({ isLoadingWageTypes: false });
        }
    }


    render() {
        const { medicalLeaves, wageType, lastUpdated, isLoadingWageTypes } = this.state;
        const { t } = this.props;
        return (
            <div className='mt-2'>
                {!!wageType.length &&
                    <WagetypeRefetch
                        t={this.props.t}
                        refetch={() => this.setState({ isLoadingWageTypes: true }, this.refetchWageType)}
                        lastUpdated={lastUpdated}
                        isLoading={isLoadingWageTypes}
                        dateTimeRules={this.props.commonStore.getDateTimeRules()}
                    />
                }
                <Row className='mt-2'>
                    <Col sm={12} >
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <label className="control-label">{t('Split medical leaves for outside employer wagetype')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("This will split the medical leaves and first half of the medical leave will come under the employer payroll wagetype and rest will be registered under the outside employer wagetype")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={2}>
                                <SwitchWidget
                                    className='mt-1'
                                    value={medicalLeaves.allowMedicalLeaveSpliting}
                                    onChange={checked => {
                                        this.handleSwitch('allowMedicalLeaveSpliting', checked);
                                        // Turning splitting off leaves the working-days option with nothing to
                                        // act on, so clear it rather than leaving a dormant true behind.
                                        if (!checked) this.handleSwitch('allowDefaultHolidaysOnMedicalLeave', false);
                                    }} />
                            </Col>
                            {medicalLeaves.allowMedicalLeaveSpliting &&
                                <Col xs={12} className="mt-1">
                                    <span className="fw-bold text-warning fs14">{t('Note')}:</span>{' '}
                                    <span className="text-muted fs14" style={{ fontStyle: 'italic' }}>
                                        {t("Medical leave splitting is based on calendar days. The employee's working days are considered based on the default holiday settings, excluding the selected default holidays")}
                                    </span>
                                </Col>
                            }
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <label className="control-label">{t('Allow default holidays on medical leave')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("If enabled, Medical leave splitting will use working days instead of calendar days")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={2}>
                                <SwitchWidget
                                    className='mt-1'
                                    value={medicalLeaves.allowDefaultHolidaysOnMedicalLeave}
                                    disabled={!this.state.enableDefaultHolidaysForAbsence || !medicalLeaves.allowMedicalLeaveSpliting}
                                    onChange={checked => this.handleSwitch('allowDefaultHolidaysOnMedicalLeave', checked)} />
                            </Col>
                            {medicalLeaves.allowDefaultHolidaysOnMedicalLeave &&
                                <Col xs={12} className="mt-1">
                                    <span className="fw-bold text-warning fs14">{t('Note')}:</span>{' '}
                                    <span className="text-muted fs14" style={{ fontStyle: 'italic' }}>
                                        {t('Medical leave splitting will use working days instead of calendar days, based on the default holiday settings and excluding the selected default holidays')}
                                    </span>
                                </Col>
                            }
                        </Row>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col sm={12} md={6}>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={8}>
                                <label className="control-label">{t('Employer Medical Leave Period (Days)')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Defines the number of days of medical leave covered by the employer")}
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={4}>
                                <NumberInput
                                    min={1}
                                    max={100}
                                    value={medicalLeaves.medicalLeaveDaysForEmployer}
                                    onChange={evt => this.handleChange('medicalLeaveDaysForEmployer', evt.target.value === '' ? '' : parseInt(evt.target.value, 10))}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={8}>
                                <label className="control-label">{t('New Employer Medical Leave Period Threshold (Days)')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Defines the number of days that must pass between medical leave periods before a new employer medical leave period starts")}
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={4}>
                                <NumberInput
                                    min={1}
                                    max={100}
                                    value={medicalLeaves.medicalLeaveNewPeriodThresholdDays}
                                    onChange={evt => this.handleChange('medicalLeaveNewPeriodThresholdDays', evt.target.value === '' ? '' : parseInt(evt.target.value, 10))}
                                />
                            </Col>
                        </Row>
                    </Col>
                    {this.payrollIntegration &&
                        <Col sm={12} md={6}>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <label className="control-label">{t('Outside Employer payroll wagetype')}
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    {t("Select the wagetype for outside employer medical leaves")}
                                                </Tooltip>
                                            }
                                        >
                                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    </label>
                                </Col>
                                <Col xs={6}>
                                    <Select
                                        menuPlacement={"top"}
                                        options={wageType?.map(item => ({ value: item.value, label: item.label, projectDbId: item.projectDbId }))}
                                        value={wageType.find(item => item.value === medicalLeaves.medicalLeaveGovtPayrollWagetype?.value)}
                                        onChange={selected => this.handleChange('medicalLeaveGovtPayrollWagetype', selected)}
                                        style={{ width: '100%' }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    }
                </Row>
            </div>
        );
    }
}
export default inject('clientStore')(withLocalization(observer(MedicalLeaves)));
